module.exports = __webpack_public_path__ + "static/img/manual-7.1f209f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-7.png
// module id = iBpX
// module chunks = 4